import { render, staticRenderFns } from "./TemplateMenu.vue?vue&type=template&id=b3747050&scoped=true&"
import script from "./TemplateMenu.vue?vue&type=script&lang=js&"
export * from "./TemplateMenu.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMenu.vue?vue&type=style&index=0&id=b3747050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3747050",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContainer,VContent})
